import {
  contractService,
  membershipService,
  weeklyScheduleService,
  type ShiftRQSchema
} from '@libs/data-access/queries'
import { usePlanningPolicies } from '@spa/scenes/Plannings/redux/selectors'
import { getRoleRights } from 'snap-redux/modules/memberships/utils'

const useRealFormValidationPermission = ({
  shiftData,
  precomputedCanValidate
}: {
  shiftData?: ShiftRQSchema
  precomputedCanValidate?: boolean
}) => {
  const currentMembershipQuery = membershipService.membership.useFetchCurrent()
  const { atLeast, exact } = getRoleRights(currentMembershipQuery.data)
  const shiftWeeklyscheduleId = shiftData?.weeklyschedule_id

  const weeklyscheduleQuery = weeklyScheduleService.api.useFetchOne(
    {
      pathParams: { id: shiftWeeklyscheduleId }
    },
    {
      enabled: Boolean(shiftWeeklyscheduleId)
    }
  )

  const shiftContractQuery = contractService.contract.useFetchOne(
    {
      pathParams: { user_contract_id: Number(shiftData?.user_contract_id) }
    },
    {
      enabled: Boolean(shiftData?.user_contract_id)
    }
  )

  const { canValidateOwnRealHours } = usePlanningPolicies()

  const computeValidationPermissionFromWeeklyschedule = () => {
    // Others views permission computation
    const isOwnShift =
      shiftContractQuery.data?.membership_id ===
      currentMembershipQuery?.data?.id

    const canValidateOwnShiftIfManager = isOwnShift
      ? canValidateOwnRealHours
      : true
    /*
     * If a manager cannot validate his own shift
     * Then we consider them as an employee
     */
    const canValidateIfManager = exact.manager
      ? canValidateOwnShiftIfManager
      : atLeast.manager

    return Boolean(
      weeklyscheduleQuery.data?.permissions?.can_validate &&
        canValidateIfManager
    )
  }

  // For Month View V2, the permissions are already provided by the backend
  const canValidate =
    precomputedCanValidate ?? computeValidationPermissionFromWeeklyschedule()

  return canValidate
}

export default useRealFormValidationPermission
